import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 bg-red-50 max-w-md mx-auto mt-10 rounded-lg">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong.</h2>
          <details className="bg-white p-4 rounded-md">
            <summary className="cursor-pointer font-semibold">Show error details</summary>
            <p className="mt-2 text-red-800">{this.state.error && this.state.error.toString()}</p>
            <p className="mt-2 text-gray-700 overflow-auto max-h-64">
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </p>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;